import { Avatar, Grid, Typography } from "@material-ui/core";
import React from "react";
import { SubmissionState } from "../../redux/state";
import {
  formatUtcDate,
  standardDateFormats,
} from "@ofqual/portal-core/core/utils/dateUtils";
import { RecordHeader } from "@ofqual/portal-components/components/RecordHeader";

type UpdateRiskHeaderProps = {
  submissionState: SubmissionState;
};

export const UpdateRiskHeader: React.FC<UpdateRiskHeaderProps> = ({
  submissionState: state,
}) => {
  const calculateInitials = (name: string): string => {
    const splitName = name.split(" ");
    let initials = "";
    splitName.forEach(
      (section: string) => (initials = initials.concat(section[0]))
    );
    return initials;
  };

  return (
    <RecordHeader>
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="stretch"
        spacing={2}
        style={{ height: "100%" }}
      >
        <Grid item>
          <Avatar
            style={{
              backgroundColor: "#293445",
              width: 70,
              height: 70,
              fontSize: 30,
            }}
          >
            {state.submission
              ? calculateInitials(state.submission.createdByDisplayName)
              : ""}
          </Avatar>
        </Grid>
        <Grid item style={{ borderRight: "1px solid white" }} xs={2}>
          <Typography variant="subtitle1">
            <strong>Reported</strong>
          </Typography>
          <Typography variant="body2">
            {state.submission?.createdByDisplayName}
          </Typography>
          <Typography variant="body2">
            {formatUtcDate(
              state.submission?.createdDate,
              standardDateFormats.DATE_TIME
            )}
          </Typography>
        </Grid>

        <Grid item>
          <Avatar
            style={{
              backgroundColor: "#293445",
              width: 70,
              height: 70,
              fontSize: 30,
            }}
          >
            {state.submission
              ? calculateInitials(
                  state.submission.modifiedByDisplayName
                    ? state.submission?.modifiedByDisplayName
                    : state.submission?.createdByDisplayName
                )
              : ""}
          </Avatar>
        </Grid>
        <Grid item xs={2} style={{ borderRight: "1px solid white" }}>
          <Typography variant="subtitle1">
            <strong>Last updated</strong>
          </Typography>
          <Typography variant="body2">
            {state.submission?.modifiedByDisplayName
              ? state.submission?.modifiedByDisplayName
              : state.submission?.createdByDisplayName}
          </Typography>
          <Typography variant="body2">
            {formatUtcDate(
              state.submission?.modifiedDate,
              standardDateFormats.DATE_TIME
            )}
          </Typography>
        </Grid>
      </Grid>
    </RecordHeader>
  );
};
